import { h, Component } from 'preact';
import * as is from 'utilities/is';
import { PLAYER_EVENT, PLAYER_CONTROL_EVENT, ANNOTATION_EVENT } from 'constants/events';
import { getComponentMap } from '../component_map';
import { applyBehaviors } from 'utilities/annotations';
import { ErrorBoundary } from 'rendering/components';
import { applyAnnotationRules } from './rules';

const ANNOTATION_INITIAL_STATE_WHITELIST = ['activitiespanel'];

export class RenderTarget extends Component {
    constructor(props) {
        super(props);

        this.componentMap = getComponentMap(this.targetName);

        this.state = {
            currentTime: -1,
            annotations: this.annotations,
            scaleFinalized: false
        };

        if (this.props.scale) {
            this.state.scale = this.props.scale;
            this.state.scaleFinalized = true;
        }
        
        props.bus.once(PLAYER_EVENT.LOADED_METADATA, this.onLoadedMetadata.bind(this));
    }

    componentWillUpdate(nextProps) {
        if (nextProps.target !== this.targetName) {
            this.componentMap = getComponentMap(nextProps.target);
        }
    }

    onClick(event) {
        if (typeof event.target.dataset.gototime !== 'undefined') {
            this.props.bus.emit(PLAYER_CONTROL_EVENT.TIME_UPDATE, +event.target.dataset.gototime);
        }
    }

    onLoadedMetadata(event) {
        this.setState({ scaleFinalized: true });
    }

    render() {
       throw 'subclass should handle rendering'; 
    }

    get targetName() {
        return this.props.target;
    }

    get annotationList() {
        return this.props.list;
    }

    get targetList() {
        const { list = [] } = this.props;

        return (
            list
                .filter(a => a.target === this.targetName)
                .filter(a => this.componentMap[a.type])
                .map(applyAnnotationRules(this.targetName))                
        )
    }

    get annotations() {
        return (
            this.targetList
                .filter(a => typeof this.componentMap[a.type])
                .map(this.renderAnnotation)
        );
    }

    get scalableAnnotations() {
        return (
            this.targetList
                .filter(a => is.defined(this.componentMap[a.type]) && (
                    is.defined(a.scalable) ? 
                        a.scalable === true :
                        this.componentMap[a.type].scalable
                ))
                .map(this.renderAnnotation)
        )
    }

    get nonScalableAnnotations() {
        return (
            this.targetList
                .filter(a => is.defined(this.componentMap[a.type]) && (
                    is.defined(a.scalable) ?
                        a.scalable === false :
                        !this.componentMap[a.type].scalable
                ))
                .map(this.renderAnnotation)
        )
    }

    renderAnnotation = (a = {}) => {
        const { state = {} } = this.props.data;
        const initialState = state.annotation?.[a.id] || {};
        const initialFormData = state.formData?.[a.id] || {};
        let AnnotationComponent = this.componentMap[a.type];
        AnnotationComponent = applyBehaviors(a, AnnotationComponent);

        const attrs = {
            initialState,
            initialFormData,
            ...this.annotationProps,
            ...a
        }

        const descendants = a.descendants?.filter(d => this.componentMap[d.type]).map(this.renderAnnotation);

        return (
            <ErrorBoundary id={ `${a.id}` } key={ `annotation-${a.id}` } name={`${a.type}-${a.id}`}>
                <AnnotationComponent { ...attrs }>
                    {descendants}
                </AnnotationComponent>
            </ErrorBoundary>
        )      
    }

    get annotationProps() {
        const state = this.state || this.defaultState;

        return {
            onClick: this.onClick.bind(this),
            bus: this.props.bus,
            currentTime: state.currentTime,
            data: this.props.data,
            muted: this.props.muted,
            dimensions: this.props.playerInterface.dimensions || {},
            parentState: state
        }
    }

    get targetStyles() {
        return {
            position: 'absolute',
            left: `${this.props.targetSize.col}%`,
            top: `${this.props.targetSize.row}%`,
            width: `${this.props.targetSize.w}%`,
            height: `${this.props.targetSize.h}%`
        }
    }

    get defaultState() {
        return {
            currentTime: -1,
            annotations: [],
            scaleFinalized: false
        };
    }
}
